import { Flex } from '@ox-technologies/ui';
import LayoutWrapper from 'components/public-layout/layout-wrapper';
import { ReactNode } from 'react';
import { usePublicLayoutSettings } from 'utils/hooks/use-public-layout-settings';

const PublicRoutesLayout = ({ children }: { children: ReactNode }) => {
  const layoutSettings = usePublicLayoutSettings();

  return (
    <LayoutWrapper {...layoutSettings}>
      <Flex
        direction="col"
        align="center"
        justify="center"
        gap={0}
        className="h-full w-full text-center"
      >
        {children}
      </Flex>
    </LayoutWrapper>
  );
};

export default PublicRoutesLayout;
